import { useState } from 'react';

import { API_AI_OPT_IN } from '../../common/EsConstants';
import { esPut } from '../../common/EsFetch';
import { useEsStrings } from '../../common/EsStrings';

/*
 * The account page's AI opt-in (es-ai-service.md §5): one box, saved at once as the voice
 * setting is, under the one copy that says what is sent and what is not. Drawn only while
 * switchEsAi is on and the account is 18 or over -- esback's aiEligible, since the page never
 * sees the birthdate -- and revocable from the same box.
 */
export default function EsAccountAi( { optIn, onChange } ) {
    const t = useEsStrings();
    const [ busy, setBusy ] = useState( false );
    const [ error, setError ] = useState( null );

    const save = async ( pWanted ) => {
        setBusy( true );
        setError( null );
        try {
            const aSaved = await esPut( API_AI_OPT_IN, { optIn: pWanted } );
            onChange?.( Boolean( aSaved?.optIn ) );
        }
        catch ( aError ) {
            setError( aError?.message ?? t( 'ai-opt-in-not-saved', 'That did not save.' ) );
        }
        finally {
            setBusy( false );
        }
    };

    return (
        <div data-testid="es-account-ai">
            <label htmlFor="aiOptIn" className="flex cursor-pointer items-center gap-3 text-base text-body">
                <input
                    type="checkbox"
                    id="aiOptIn"
                    name="aiOptIn"
                    data-testid="es-account-ai-optin"
                    checked={ Boolean( optIn ) }
                    disabled={ busy }
                    onChange={ ( pEvent ) => save( pEvent.target.checked ) }
                    className="size-4 shrink-0 accent-accent" />
                { t( 'ai-opt-in', 'Let the AI assistant help me' ) }
            </label>
            <p data-testid="es-account-ai-sent" className="mt-2 text-xs text-aside">
                { t( 'ai-opt-in-sent', 'What is sent: your draft, your words, and open content you can read.' ) }
            </p>
            <p data-testid="es-account-ai-not-sent" className="mt-1 text-xs text-aside">
                { t( 'ai-opt-in-not-sent', 'What is not: your account, other people\'s packs, and proprietary text.' ) }
            </p>
            <p className="mt-1 text-xs text-aside">
                { t( 'ai-opt-in-revoke', 'Untick the box at any time to stop.' ) }
            </p>
            { error && <p data-testid="es-account-ai-error" role="alert" className="mt-2 text-xs text-danger">{ error }</p> }
        </div>
    );
}
